import React from "react";
import { AIMemoryModalWrapper } from "../ai-memory-modal/AIMemoryModalWrapper";
import { AIDeepLinkSync } from "../chat/ai-chat/AIDeeplinkSync";
import { ChatPlusCalendarDateSync } from "../chat/ai-chat/ChatPlusCalendarDateSync";
import { AIErrorProvider } from "../chat/ai-chat/hooks/AIErrorContext";
import { StorageKeyPrefixProvider } from "../web-app-calendar/hooks/useStorageKeyPrefix";
import AIChat from "./AIChat";
import { Calendar } from "./Calendar";
import Context from "./Context";

export const AIChatPlusCalendar = () => {
  return (
    <AIErrorProvider>
      <Context>
        <AIDeepLinkSync />
        <ChatPlusCalendarDateSync />
        <AIMemoryModalWrapper />
        <div
          cw-id="chatPlusCalendar"
          className="cw-flex cw-flex-row cw-grow cw-justify-items-end cw-w-full cw-h-full"
        >
          <div className="cw-self-end cw-h-full cw-flex lg:cw-w-[420px] cw-w-full  cw-border-r cw-border-subtle cw-border-solid">
            <AIChat />
          </div>
          <div className="cw-grow cw-flex-1 cw-overflow-hidden">
            <div className="lg:cw-flex cw-hidden lg:cw-w-full cw-transition-all cw-h-full">
              <StorageKeyPrefixProvider prefix="ai-chat">
                <Calendar />
              </StorageKeyPrefixProvider>
            </div>
          </div>
        </div>
      </Context>
    </AIErrorProvider>
  );
};

export default AIChatPlusCalendar;
